import { render, staticRenderFns } from "./NewsLine.vue?vue&type=template&id=6e049b3e&scoped=true&"
import script from "./NewsLine.vue?vue&type=script&lang=js&"
export * from "./NewsLine.vue?vue&type=script&lang=js&"
import style0 from "./NewsLine.vue?vue&type=style&index=0&id=6e049b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e049b3e",
  null
  
)

export default component.exports